import { createSelector } from 'reselect'
import { State } from '../../reducers/reducerType'
import username from '../../../lib/username'
import selectDialInParticipants from '../selectDialInParticipants'

/**
 * Returns a boolean stating if the current user is also signed in as a dial-in participant
 * @param state The Redux state
 */

const getDialedInParticipants = (state: State): string[] => selectDialInParticipants(state)
const getLocalBTID = (state: State): string | null => state.user.BTID

export default createSelector(
  [getDialedInParticipants, getLocalBTID],
  (dialedInParticipants, localBTID): boolean =>
    !!dialedInParticipants.find(_username => username.getPureUsername(_username) === localBTID)
)
